module.exports = __webpack_public_path__ + "static/media/cardFive.45b412b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowOne/cardFive.jpg
// module id = 80
// module chunks = 0